import { Component, input, output } from "@angular/core";

@Component({
  selector: "app-dashboard-item",
  imports: [],
  templateUrl: "./dashboard-item.component.html",
  styles: ``,
})
export class DashboardItemComponent {
  color = input("green");

  canClick = input<boolean>(false);
  click = output<void>();
}
